import { render, staticRenderFns } from "./ProfessionalDetailsSection.vue?vue&type=template&id=154e9827"
import script from "./ProfessionalDetailsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalDetailsSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports